var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShirtIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2239 3.67676H8.8221L7.05304 5.48798H2.14258V12.7721H5.59252V22.1196H18.3333V12.5766H21.858V5.48798H16.8224L15.2239 3.67676ZM8.3263 7.04671L8.93326 6.42528L10.4709 7.95842L9.50652 8.78885L8.3263 7.04671ZM11.8053 6.46462L11.0151 5.67676H12.6585L11.8053 6.46462ZM13.141 7.95346L14.8986 6.3306L15.4361 6.93963L14.228 8.81226L13.141 7.95346ZM6.20951 7.48798H4.14258V10.7721H7.59252V20.1196H16.3333V10.5766H19.858V7.48798H17.4624L14.7154 11.7462L11.8063 9.44783L9.11009 11.7696L6.20951 7.48798ZM12.5533 12.1092C12.5533 12.4691 12.2616 12.7608 11.9017 12.7608C11.5418 12.7608 11.25 12.4691 11.25 12.1092C11.25 11.7493 11.5418 11.4575 11.9017 11.4575C12.2616 11.4575 12.5533 11.7493 12.5533 12.1092ZM11.9017 15.8155C12.2616 15.8155 12.5533 15.5238 12.5533 15.1639C12.5533 14.804 12.2616 14.5122 11.9017 14.5122C11.5418 14.5122 11.25 14.804 11.25 15.1639C11.25 15.5238 11.5418 15.8155 11.9017 15.8155ZM12.5533 18.221C12.5533 18.5809 12.2616 18.8726 11.9017 18.8726C11.5418 18.8726 11.25 18.5809 11.25 18.221C11.25 17.8611 11.5418 17.5693 11.9017 17.5693C12.2616 17.5693 12.5533 17.8611 12.5533 18.221Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirtIcn);
export default __webpack_public_path__ + "static/media/shirt-icn.e04ed6e63a16b8acd1bf4d519b36f440.svg";
export { ForwardRef as ReactComponent };